import { Injectable } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { ViewStateRecordsAlias } from "@common/services/layout-state";
import { NavigationService } from '@common/services/navigation-service';
import { SlideshowViewStateRecord } from "@common/data-models/records/slideshow-viewstate-record";
import { PlanningViewsResults } from "@common/data-models/navigation/planning-views-results";
import { DataStore } from "@common/data-models/data-store/data-store";
import { ViewStateRecord } from "@common/data-models/records/viewstate-record";
import { ViewStateSequenceSerializer } from "@common/data-models/serializers/serializers";
import { ViewStateSequence } from "@common/data-models/navigation/viewstate-sequence";
import { ViewStateDef } from "@common/data-models/navigation/viewstate-def";
import { SingleViewStateRecord } from "@common/data-models/records/single-viewstate-record";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { ViewStateSortOders } from "@common/enums/viewstate-sort-orders";

@Injectable({ providedIn: 'root' })
export class SlideshowService {
    
    public static MinSlideshowDelay: number = 1;
    public static MaxSlideshowDelay: number = Infinity;
    public static DefaultSlideshowDelay: number = 5; // In seconds
    private static SlideshowMultiplier: number = 1000;

    public ViewStateRecord: ViewStateRecordsAlias = null;
    public ViewStateRecordSubject = new Subject<ViewStateRecordsAlias>();
    public ViewStateRecordObservable = this.ViewStateRecordSubject.asObservable();

    private slideshow: SlideshowViewStateRecord = null;
    private index: number = -1;
    private sequence: ViewStateSequence = null;
    private viewstate: ViewStateRecord = null;

    private viewstates: { [guid: string]: ViewStateRecord } = {};
    private timeout: any = null;
    
    constructor() {}

    public initialize(vs: SlideshowViewStateRecord) {
        let viewstates = DataStore.getSingleViewStates("playbook");
        for (let i = 0; i<viewstates.length; i++) {
            this.viewstates[viewstates[i].guid] = viewstates[i];
        }
        let res = ViewStateSequenceSerializer.Instance.initialize(viewstates, vs.viewStateSlideshowSequence);
        vs.viewStateSlideshowSequence = res;
        this.slideshow = vs;
        this.sequence = this.slideshow.viewStateSlideshowSequence;
    }
    
    public start() {
        this.index = -1;
        this.next();
    }

    private find(): ViewStateDef {
        // Find next viewstate
        for (let i = 0; i < this.sequence.viewstates.length; i++) {
            if (i > this.index && this.sequence.viewstates[i].Selected) {
                // Next viewstate found
                this.index = i;
                return this.sequence.viewstates[i];
            }
        }
        return null;
    }

    public next() {
        // Clear current viewstate
        if (this.index > -1) this.sequence.viewstates[this.index].Current = false;

        // Find next viewstate
        let vs = this.find();

        if (!vs) {
            // Reached end - start from begining
            this.index = -1;
            vs = this.find();
        }

        if (vs) {
            vs.Current = true;
            let viewstate = this.viewstates[vs.Guid];
            // Set default sort order base on the sorting property. If sorting by date, we want to start wit descending by default
            if (viewstate instanceof SingleViewStateRecord) {
                if (viewstate.viewStateSorting.Value == PSTFieldNames.PSTTopicFileDate) {
                    viewstate.viewStateSortOrder = ViewStateSortOders.DESC;
                } else {
                    viewstate.viewStateSortOrder = ViewStateSortOders.ASC;
                }
            }
            this.ViewStateRecordSubject.next(<ViewStateRecordsAlias>viewstate);
        }
    }

    public process() {
        let delay: number = this.slideshow.viewStateSlideshowDelay.Value * SlideshowService.SlideshowMultiplier;
        if (this.timeout) clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
            this.next();
        }, delay);
    }

    public stop() {

    }

    public pause() {

    }


}
